import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE } from "./Reveal";
import { CATEGORY_META } from "../data/site";

export default function ProductCard({ product, onRequestQuote, index = 0 }) {
  const categoryName = CATEGORY_META[product.category]?.name || product.category;
  return (
    <motion.article
      data-testid={`product-card-${product.slug}`}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: EASE }}
      className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-all duration-300 hover:-translate-y-1.5 hover:border-forest/40 hover:shadow-[0_28px_60px_-24px_rgba(6,78,59,0.35)]"
    >
      <Link to={`/products/${product.slug}`} className="relative block">
        <div className="overflow-hidden rounded-b-[2.5rem]">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="img-editorial aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
          />
        </div>
        {product.badge && (
          <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1.5 font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-forest backdrop-blur">
            {product.badge}
          </span>
        )}
        <span className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-ink opacity-0 backdrop-blur transition-all duration-300 group-hover:opacity-100">
          <ArrowUpRight className="h-4 w-4" />
        </span>
      </Link>

      <div className="flex flex-1 flex-col gap-3 p-6">
        <div className="flex flex-wrap items-center gap-2 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-emerald-700">
          <span>{categoryName}</span>
          <span className="h-1 w-1 rounded-full bg-gold" />
          <span className="text-slate-400">HS {product.hs_code}</span>
        </div>
        <h3 className="font-display text-xl font-semibold text-ink">{product.name}</h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-slate-500">{product.tagline}</p>

        <div className="mt-auto flex items-center justify-between gap-3 border-t border-slate-100 pt-4">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400">MOQ</p>
            <p className="text-sm font-semibold text-ink">{product.moq}</p>
          </div>
          <button
            data-testid={`quote-${product.slug}-button`}
            onClick={() => onRequestQuote?.(product)}
            className="shrink-0 rounded-full border border-forest/25 px-4 py-2 text-xs font-semibold text-forest transition-colors hover:bg-forest hover:text-white"
          >
            Request Quote
          </button>
        </div>
      </div>
    </motion.article>
  );
}
